import React, { Component } from 'react';
import _ from 'lodash';
import {
  Label,
} from 'reactstrap';
import ProgressButton from '../../../commons/ProgressButton';
import Service from './services';
import { DatePicker } from '../../../commons/controls';
import FileSaver from 'file-saver';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';

class Lekerdezes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lekerdezesOptions: [
        <option value={'DOLGOZO'}>{'Dolgozó'}</option>,
        <option value={'HELYSZIN'}>{'Helyszín'}</option>,
        <option value={'IDO'}>{'Idő'}</option>,
        <option value={'SZOLGALTATAS'}>{'Szolgáltatás'}</option>,
        <option value={'TEREM'}>{'Terem'}</option>
      ],
      idoOptions: [
        <option value={'NAP'}>{'Napi'}</option>,
        <option value={'HET'}>{'Heti'}</option>,
        <option value={'HONAP'}>{'Havi'}</option>,
        <option value={'EV'}>{'Évi'}</option>
      ],
      intervallumOptions: [
        <option value={'teljes'}>{'Teljes intervallum'}</option>,
        <option value={'tegnap'}>{'Tegnapi nap'}</option>,
        <option value={'elozohet'}>{'Előző hét'}</option>,
        <option value={'elozohonap'}>{'Előző hónap'}</option>,
        <option value={'elozoev'}>{'Előző év'}</option>,
        <option value={'egyeni'}>{'Egyéni intervallum'}</option>
      ],
      lekerdezesFilterSelected: null,
      idoFilterSelected: null,
      intervallumFilterSelected: null,
      ar: false,
      foglalasszam: false,
      megjelenesszam: false,
      kezdoDatum: null,
      zaroDatum: null,
      disabled: true,
      egyeniIntervallum: false,

      lekerdezesButtonLoading: false,
    };
  }

  updateIntervallum = () => {
    const kezdoDate = new Date();
    const zaroDate = new Date();
    kezdoDate.setHours(0);
    kezdoDate.setMinutes(0);
    kezdoDate.setSeconds(0);
    zaroDate.setHours(0);
    zaroDate.setMinutes(0);
    zaroDate.setSeconds(0);
    switch (this.state.intervallumFilterSelected) {
      case "tegnap":
        kezdoDate.setDate(kezdoDate.getDate() - 1);
        this.setState({ kezdoDatum: kezdoDate, zaroDatum: kezdoDate });
        break;
      case "elozohet":
        //Előző hétfő ami nem ezen a héten van
        kezdoDate.setDate(kezdoDate.getDate() - (kezdoDate.getDay() + 6) % 7 - 7);
        zaroDate.setDate(zaroDate.getDate() - (zaroDate.getDay() + 6) % 7 - 1);
        this.setState({ kezdoDatum: kezdoDate, zaroDatum: zaroDate });
        break;
      case "elozohonap":
        kezdoDate.setMonth(kezdoDate.getMonth() - 1);
        //1 = a hónap első napja
        kezdoDate.setDate(1);
        //0 = az előző hónap utolsó napja
        zaroDate.setDate(0);
        this.setState({ kezdoDatum: kezdoDate, zaroDatum: zaroDate });
        break;
      case "elozoev":
        kezdoDate.setFullYear(kezdoDate.getFullYear() - 1);
        kezdoDate.setMonth(0);
        kezdoDate.setDate(1);
        //Az év első hónapjára állítjuk, majd az előző hónap (előző év december) utolsó napjára
        zaroDate.setMonth(0);
        zaroDate.setDate(0);
        this.setState({ kezdoDatum: kezdoDate, zaroDatum: zaroDate });
        break;
      case "teljes":
        this.setState({ kezdoDatum: null, zaroDatum: null });
        break;
      case "egyeni":
        this.setState({ kezdoDatum: null, zaroDatum: null });
        break;
    }
  }

  handleLekerdezesSelect = (event, value) => {
    this.setState({ lekerdezesFilterSelected: value });
  }

  handleIdoSelect = (event, value) => {
    this.setState({ idoFilterSelected: value });
  }

  handleIntervallumSelect = (event, value) => {
    if (value == "egyeni") {
      this.setState({ egyeniIntervallum: true });
    } else {
      this.setState({ egyeniIntervallum: false });
    }
    this.setState({ intervallumFilterSelected: value }, () => {
      this.updateIntervallum();
    });
  }

  handleCheckboxChange = (e) => {
    const { target } = e;
    const value = target.checked;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleButtonDisable = () => {
    if (this.state.lekerdezesFilterSelected == null ||
      (this.state.lekerdezesFilterSelected == "IDO" && this.state.idoFilterSelected == null) ||
      (!this.state.ar && !this.state.foglalasszam && !this.state.megjelenesszam) ||
      (this.state.intervallumFilterSelected == "egyeni" && (this.state.kezdoDatum == null || this.state.zaroDatum == null))) {
      return true;
    }
    return false;
  }

  onSubmit = (event, submitObj) => {
    submitObj.statisztikaEnum = this.state.lekerdezesFilterSelected;
    submitObj.kimenetEnumList = [];
    if (this.state.ar)
      submitObj.kimenetEnumList.push("AR");
    if (this.state.foglalasszam)
      submitObj.kimenetEnumList.push("FOGLALAS");
    if (this.state.megjelenesszam)
      submitObj.kimenetEnumList.push("MEGJELENES");
    submitObj.idoEnum = this.state.idoFilterSelected;
    this.setState({ lekerdezesButtonLoading: true });
    Service.statisztikaXlsx(submitObj, this.state.kezdoDatum, this.state.zaroDatum, (err, res) => {
      if (!err) {
        this.props.globals.addSuccess('Statisztika XLSX letöltése...');
        FileSaver.saveAs(new Blob([res[0]], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', responseType: 'arraybuffer' }), 'STATISZTIKAK.xlsx');
      }
      this.setState({ lekerdezesButtonLoading: false });
    });
  }

  render() {
    let cardStyle = {
      padding: 20
    };
    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              Lekérdezés
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <React.Fragment>
                  <RFForm onSubmit={this.onSubmit}>
                    <div className="row">
                      <div className="col-md-3">
                        <Label for="lekerdezesselect">
                          
                        </Label>
                        <RFField
                          label="Lekérdezés alapja:"
                          type="select"
                          name="lekerdezesselect"
                          value={this.state.lekerdezesFilterSelected}
                          onChange={this.handleLekerdezesSelect}
                          defaultSelect={<option value='' disabled>Válassza ki a lekérdezés alapját...</option>}
                          selectOptions={this.state.lekerdezesOptions}
                        />
                      </div>
                      <div className="col-md-3" hidden={this.state.lekerdezesFilterSelected == 'IDO' ? false : true}>
                        <RFField
                          label="Bontás:"
                          type="select"
                          name="idoselect"
                          value={this.state.idoFilterSelected}
                          onChange={this.handleIdoSelect}
                          defaultSelect={<option value='' disabled>Válassza ki milyen bontást szeretne...</option>}
                          selectOptions={this.state.idoOptions}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-2">
                        <RFField
                          label="Intervallum: "
                          type="select"
                          name="intervallum"
                          value={this.state.intervallumFilterSelected}
                          onChange={this.handleIntervallumSelect}
                          selectOptions={this.state.intervallumOptions}
                        />
                      </div>
                      <div className="col-md-3" hidden={!this.state.egyeniIntervallum}>
                        <DatePicker
                          label="Kezdő dátum:"
                          id='kezdodatum'
                          name='kezdodatum'
                          value={this.state.kezdoDatum}
                          onChange={(e, v) => {let date = new Date(v); date.setHours(0); date.setMinutes(0); this.setState({ kezdoDatum: date })}}
                        />
                      </div>
                      <div className="col-md-3" hidden={!this.state.egyeniIntervallum}>
                        <DatePicker
                          label="Záró dátum:"
                          id='zarodatum'
                          name='zarodatum'
                          value={this.state.zaroDatum}
                          onChange={(e, v) => {let date = new Date(v); date.setHours(0); date.setMinutes(0); this.setState({ zaroDatum: date })}}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-2">
                        <Label for="adat">Lekérdezendő adat:
                          <div name="adat">
                            <div style={{ marginTop: 10 }}>
                              <RFField label="Ár" type="checkbox" name="ar" value={this.state.ar} onChange={this.handleCheckboxChange} />
                            </div>
                            <div style={{ marginTop: 10 }}>
                              <RFField label="Foglalásszám" type="checkbox" name="foglalasszam" value={this.state.foglalasszam} onChange={this.handleCheckboxChange} />
                            </div>
                            <div style={{ marginTop: 10, marginBottom: 20 }}>
                              <RFField label="Megjelenésszám" type="checkbox" name="megjelenesszam" value={this.state.megjelenesszam} onChange={this.handleCheckboxChange} />
                            </div>
                          </div>
                        </Label>
                      </div>
                    </div>
                    <div className="row">
                      <div class="col-md-1">
                        <ProgressButton color="primary" id="search" loading={this.state.lekerdezesButtonLoading} disabled={this.handleButtonDisable()} >Lekérdezés</ProgressButton>
                      </div>
                    </div>
                  </RFForm>
                </React.Fragment>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Lekerdezes;